if (!customElements.get('smileat-faqs')) {
  class SmileatFaqs extends HTMLElement {
    constructor() {
      super();
      this.categoryButtons = this.querySelectorAll('.faq__category-btn');
      this.questionGroups = this.querySelectorAll('.faq__group');
      
      this.categoryButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          this.switchCategory(e.currentTarget.dataset.category);
        });
      });

      this.initAccordions();

      // Initialize state if needed (Liquid handles first item, but JS can reinforce)
      const activeBtn = this.querySelector('.faq__category-btn.is-active');
      if (activeBtn) {
        this.switchCategory(activeBtn.dataset.category);
      }
    }

    initAccordions() {
      this.querySelectorAll('.faq__accordion').forEach(accordion => {
        const summary = accordion.querySelector('summary');
        const content = accordion.querySelector('.faq__accordion-content');
        
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          if (accordion.classList.contains('is-animating')) return;

          const isOpening = !accordion.hasAttribute('open');
          accordion.classList.add('is-animating');

          if (isOpening) {
            this.openAccordion(accordion, content);
          } else {
            this.closeAccordion(accordion, content);
          }
        });
      });
    }

    openAccordion(accordion, content) {
      accordion.setAttribute('open', '');
      const height = content.scrollHeight;
      
      content.style.height = '0';
      
      requestAnimationFrame(() => {
        accordion.classList.add('is-open');
        content.style.height = `${height}px`;
      });

      const onEnd = (e) => {
        if (e.propertyName === 'height') {
          content.style.height = 'auto';
          accordion.classList.remove('is-animating');
          content.removeEventListener('transitionend', onEnd);
        }
      };
      content.addEventListener('transitionend', onEnd);
    }

    closeAccordion(accordion, content) {
      const height = content.scrollHeight;
      content.style.height = `${height}px`;
      accordion.classList.add('is-closing');
      accordion.classList.remove('is-open');

      requestAnimationFrame(() => {
        content.style.height = '0';
      });

      const onEnd = (e) => {
        if (e.propertyName === 'height') {
          accordion.removeAttribute('open');
          accordion.classList.remove('is-closing', 'is-animating');
          content.style.height = '';
          content.removeEventListener('transitionend', onEnd);
        }
      };
      content.addEventListener('transitionend', onEnd);
    }

    switchCategory(categoryId) {
      // Update Buttons
      this.categoryButtons.forEach(btn => {
        if (btn.dataset.category === categoryId) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
        } else {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-selected', 'false');
        }
      });

      // Update Groups
      this.questionGroups.forEach(group => {
        if (group.dataset.category === categoryId) {
          group.classList.add('is-active');
        } else {
          group.classList.remove('is-active');
        }
      });

      // Optional: Close all accordions in secondary groups if needed
      // Or just let them maintain state. Standard behavior is to keep state usually.
    }
  }

  customElements.define('smileat-faqs', SmileatFaqs);
}
